"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pcbEditorBehaviors = void 0;
exports.pcbEditorBehaviors = {
    gridPositionInMetersDecimals: 7, // since scene is in meters this allows for precision up to 0.0635mm (0.0000635m).
    gridPositionInMmDecimals: 4, // same as gridPositionInMetersDecimals but for mm inputs
    gridPositionInRadDecimals: 5, // same as gridPositionInMetersDecimals but for mm inputs
    gridPositionInDegDecimals: 0, // same as gridPositionInMetersDecimals but for mm inputs
    unfocussedLayerOpacity: 0.2,
};
//# sourceMappingURL=behaviors.js.map